"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = exports.DEALER_QUERY = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _graphqlTag = _interopRequireDefault(require("graphql-tag"));
var _reactApollo = require("react-apollo");
var _dealerDetails = _interopRequireDefault(require("../styles/dealerDetails.css"));
var _dealerLocator = _interopRequireDefault(require("../styles/dealer-locator.css"));
var _backButton = _interopRequireDefault(require("./back-button"));
var _dealerAddress = _interopRequireDefault(require("./dealer/dealer-address"));
var _dealerContact = _interopRequireDefault(require("./dealer/dealer-contact"));
var _dealerDepartments = _interopRequireDefault(require("./dealer/dealer-departments"));
var _dealerDistance = _interopRequireDefault(require("./dealer/dealer-distance"));
var _dealerHours = _interopRequireDefault(require("./dealer/dealer-hours"));
var _directions = _interopRequireDefault(require("./directions"));
var _marker = _interopRequireDefault(require("./marker"));
var _sideBySideButtons = _interopRequireDefault(require("./side-by-side-buttons"));
var _starRating = _interopRequireDefault(require("./star-rating"));
var _dealerLogo = _interopRequireDefault(require("./dealer/dealer-logo"));
var _checkProps = _interopRequireDefault(require("../utils/checkProps"));
var _constants = require("../constants");
var _types = _interopRequireDefault(require("./types"));
var _templateObject;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var isLogo = function isLogo(logo) {
  if (logo && logo !== null && logo !== '') {
    return true;
  }
  return false;
};
var DEALER_QUERY = (0, _graphqlTag["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2["default"])(["\n  query getDealerDetail(\n    $market: String!\n    $language: String!\n    $dealerId: Int!\n    $path: String\n  ) {\n    getDealerDetail(\n      market: $market\n      language: $language\n      dealerId: $dealerId\n      path: $path\n    ) {\n      email\n      phone {\n        phoneType\n        countryCode\n        areaCode\n        phoneNumber\n        extensionNumber\n      }\n      dealerFilterTags\n      dealerDepartments {\n        name\n        code\n        email\n        phone {\n          phoneType\n          countryCode\n          areaCode\n          phoneNumber\n          extensionNumber\n        }\n        workingHours {\n          dayOfTheWeek\n          openTime\n          closeTime\n          status\n        }\n      }\n      scheduleServiceUrl\n      searchInventoryUrl\n      serviceWebsite\n      socialLabel\n      socialMediaLinks {\n        socialMediaType\n        socialMediaLabel\n        socialMediaUrl\n      }\n    }\n  }\n"])));
exports.DEALER_QUERY = DEALER_QUERY;
var queryParams = function queryParams(dealerId, config, path) {
  return {
    dealerId: dealerId,
    market: config.market,
    language: config.language,
    path: path
  };
};
var DealerDetails = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(DealerDetails, _Component);
  function DealerDetails(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.detailsInnerContainer = /*#__PURE__*/_react["default"].createRef();
    _this.focusLabel = /*#__PURE__*/_react["default"].createRef();
    _this.handleContactUsClick = _this.handleContactUsClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleTestDriveClick = _this.handleTestDriveClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleCarServiceClick = _this.handleCarServiceClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleEmailClick = _this.handleEmailClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePhoneClick = _this.handlePhoneClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = DealerDetails.prototype;
  _proto.componentDidMount = function componentDidMount() {
    if (this.focusLabel.current !== null) this.focusLabel.current.focus();
  };
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var dealer = this.props.dealer;
    return nextProps.dealer.id !== dealer.id;
  };
  _proto.handleContactUsClick = function handleContactUsClick(e) {
    e.stopPropagation();
    var elmntToView = document.getElementById('contact-us');
    elmntToView.scrollIntoView({
      behavior: 'smooth'
    });
  };
  _proto.handleTestDriveClick = function handleTestDriveClick() {
    var market = this.props.config.market;
    var name = this.props.dealer.name;
    if ((market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'test_drive_request_click',
        comp_product: {
          position: 'page',
          vehicle_type: 'car',
          brand: 'mitsubishi',
          product_condition: 'new',
          model: null,
          version: null,
          fuel_type: null,
          dealer_name: name.toLowerCase()
        }
      });
    }
  };
  _proto.handleCarServiceClick = function handleCarServiceClick() {
    var market = this.props.config.market;
    var name = this.props.dealer.name;
    if ((market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'maintenance_request_click',
        comp_product: {
          position: 'page',
          vehicle_type: 'car',
          brand: 'mitsubishi',
          product_condition: 'new',
          model: null,
          version: null,
          fuel_type: null,
          dealer_name: name.toLowerCase()
        }
      });
    }
  };
  _proto.handleEmailClick = function handleEmailClick(emailClicked) {
    var market = this.props.config.market;
    if ((market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'email_click',
        comp_page: {
          mail_to: emailClicked.toLowerCase()
        }
      });
    }
  };
  _proto.handlePhoneClick = function handlePhoneClick(phoneClicked) {
    var market = this.props.config.market;
    if ((market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'phone_click',
        comp_page: {
          phone_ctc: phoneClicked
        }
      });
    }
  };
  _proto.render = function render() {
    var _this2 = this,
      _BackButton,
      _Marker,
      _Rating,
      _DealerDistance,
      _Directions,
      _DealerLogo;
    var _this$props = this.props,
      clear = _this$props.clear,
      theme = _this$props.theme,
      path = _this$props.path,
      currentLocation = _this$props.currentLocation,
      dealer = _this$props.dealer,
      _this$props$dealer = _this$props.dealer,
      name = _this$props$dealer.name,
      id = _this$props$dealer.id,
      pinLabel = _this$props$dealer.pinLabel,
      distance = _this$props$dealer.distance,
      rating = _this$props$dealer.rating,
      address = _this$props$dealer.address,
      logo = _this$props$dealer.logo,
      dealershipMarketId = _this$props$dealer.dealershipMarketId,
      testDriveCTA = _this$props.testDriveCTA,
      carServiceCTA = _this$props.carServiceCTA,
      clickShopCTA = _this$props.clickShopCTA,
      clickshopParamters = _this$props.clickshopParamters,
      config = _this$props.config,
      metricSystem = _this$props.metricSystem,
      saleOpeningHoursLabel = _this$props.saleOpeningHoursLabel,
      serviceOpeningHoursLabel = _this$props.serviceOpeningHoursLabel,
      contactLabel = _this$props.contactLabel,
      showRating = _this$props.showRating,
      getDirectionsLabel = _this$props.getDirectionsLabel,
      salesLabel = _this$props.salesLabel,
      servicesLabel = _this$props.servicesLabel,
      usedCarsSalesLabel = _this$props.usedCarsSalesLabel,
      bodyAndPaintLabel = _this$props.bodyAndPaintLabel,
      languageDirection = _this$props.languageDirection,
      additionalFilters = _this$props.additionalFilters,
      searchInventoryLabel = _this$props.searchInventoryLabel,
      scheduleServiceLabel = _this$props.scheduleServiceLabel,
      contactUsLabel = _this$props.contactUsLabel,
      zipCode = _this$props.zipCode,
      serviceWebsiteCTALabel = _this$props.serviceWebsiteCTALabel,
      contactSectionOnTop = _this$props.contactSectionOnTop;
    return /*#__PURE__*/_react["default"].createElement(_reactApollo.Query, {
      query: DEALER_QUERY,
      variables: queryParams(id, config, path)
    }, function (_ref) {
      var loading = _ref.loading,
        data = _ref.data;
      // TODO: build proper hanlding for additional services
      var departmentstoUseForHours = [];
      var serviceWebsiteUrl = '';
      var socialLabel;
      var socialMediaLinks = [];
      if (data) {
        if (data.getDealerDetail) {
          var _data$getDealerDetail, _data$getDealerDetail2;
          departmentstoUseForHours = data.getDealerDetail.dealerDepartments.filter(function (department) {
            return department.workingHours.length > 0;
          });
          serviceWebsiteUrl = data.getDealerDetail.serviceWebsite;
          socialLabel = data == null ? void 0 : (_data$getDealerDetail = data.getDealerDetail) == null ? void 0 : _data$getDealerDetail.socialLabel;
          socialMediaLinks = data == null ? void 0 : (_data$getDealerDetail2 = data.getDealerDetail) == null ? void 0 : _data$getDealerDetail2.socialMediaLinks;
        }
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _dealerDetails["default"].consoleContainer,
        ref: _this2.detailsInnerContainer
      }, _BackButton || (_BackButton = /*#__PURE__*/_react["default"].createElement(_backButton["default"], {
        clear: clear
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _dealerLocator["default"].loader + " " + (loading && _dealerLocator["default"].isLoading)
      }), !loading && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _dealerDetails["default"].dealerPageHeader
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _dealerDetails["default"].headerHeading
      }, /*#__PURE__*/_react["default"].createElement("h1", {
        className: theme.headingFour + " " + _dealerDetails["default"].dealerDetailsHeadline,
        ref: _this2.focusLabel,
        tabIndex: -1
      }, name), /*#__PURE__*/_react["default"].createElement("div", {
        className: _dealerDetails["default"].markerDistance
      }, _Marker || (_Marker = /*#__PURE__*/_react["default"].createElement(_marker["default"], {
        active: true,
        label: pinLabel,
        id: id
      })), showRating && rating !== null && (_Rating || (_Rating = /*#__PURE__*/_react["default"].createElement(_starRating["default"], {
        rating: rating,
        languageDirection: languageDirection
      }))), _DealerDistance || (_DealerDistance = /*#__PURE__*/_react["default"].createElement(_dealerDistance["default"], {
        theme: theme,
        distance: distance,
        metricSystem: metricSystem
      })))), address && /*#__PURE__*/_react["default"].createElement(_dealerAddress["default"], {
        theme: theme,
        address: address,
        addressOrder: _constants.addressOrderMap[config.market]
      }), data && data.getDealerDetail.dealerDepartments && /*#__PURE__*/_react["default"].createElement(_dealerDepartments["default"], {
        dealerDepartments: data.getDealerDetail.dealerDepartments,
        dealerFilterTags: data.getDealerDetail.dealerFilterTags,
        theme: theme,
        salesLabel: salesLabel,
        usedCarsSalesLabel: usedCarsSalesLabel,
        servicesLabel: servicesLabel,
        bodyAndPaintLabel: bodyAndPaintLabel,
        additionalFilters: additionalFilters
      }), !(0, _checkProps["default"])(address) && !(0, _checkProps["default"])(currentLocation) && (_Directions || (_Directions = /*#__PURE__*/_react["default"].createElement(_directions["default"], {
        theme: theme,
        address: address,
        currentLocation: currentLocation,
        dealer: dealer,
        getDirectionsLabel: getDirectionsLabel
      }))), (testDriveCTA && testDriveCTA.URL || carServiceCTA && carServiceCTA.URL || scheduleServiceLabel && data.getDealerDetail.scheduleServiceUrl || searchInventoryLabel && data.getDealerDetail.searchInventoryUrl || serviceWebsiteCTALabel && serviceWebsiteUrl) && /*#__PURE__*/_react["default"].createElement(_sideBySideButtons["default"], {
        theme: theme,
        dealershipMarketId: dealershipMarketId,
        testDriveCTA: testDriveCTA,
        handleTestDriveClick: _this2.handleTestDriveClick,
        carServiceCTA: carServiceCTA,
        clickShopCTA: clickShopCTA,
        clickshopParamters: clickshopParamters,
        handleCarServiceClick: _this2.handleCarServiceClick,
        address: address,
        zipCodeDealer: address.postalArea,
        dealerDepartments: data && data.getDealerDetail.dealerDepartments,
        scheduleServiceLabel: scheduleServiceLabel,
        scheduleServiceUrl: data && data.getDealerDetail.scheduleServiceUrl,
        searchInventoryLabel: searchInventoryLabel,
        searchInventoryUrl: data && data.getDealerDetail.searchInventoryUrl,
        contactUsLabel: contactUsLabel,
        zipCode: zipCode,
        serviceWebsiteCTALabel: serviceWebsiteCTALabel,
        serviceWebsiteUrl: serviceWebsiteUrl,
        handleContactUsClick: _this2.handleContactUsClick
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _dealerDetails["default"].dealerDetailsSection + " " + (contactSectionOnTop && _dealerDetails["default"].contactSectionOnTop)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _dealerDetails["default"].dealerHoursSection
      }, data && data.getDealerDetail.dealerDepartments && data.getDealerDetail.dealerDepartments.length > 0 && !(0, _checkProps["default"])(saleOpeningHoursLabel) && !(0, _checkProps["default"])(serviceOpeningHoursLabel) && /*#__PURE__*/_react["default"].createElement(_dealerHours["default"], {
        dealerDepartments: departmentstoUseForHours,
        saleOpeningHoursLabel: saleOpeningHoursLabel,
        serviceOpeningHoursLabel: serviceOpeningHoursLabel,
        theme: theme
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _dealerDetails["default"].dealerContactSection
      }, /*#__PURE__*/_react["default"].createElement(_dealerContact["default"], {
        theme: theme,
        dealer: dealer,
        contactLabel: contactLabel,
        departments: data.getDealerDetail.dealerDepartments,
        salesLabel: salesLabel,
        usedCarsSalesLabel: usedCarsSalesLabel,
        servicesLabel: servicesLabel,
        bodyAndPaintLabel: bodyAndPaintLabel,
        emailClickHandler: _this2.handleEmailClick,
        phoneClickHandler: _this2.handlePhoneClick,
        socialLabel: socialLabel,
        socialMediaLinks: socialMediaLinks
      }))), isLogo(logo) && (_DealerLogo || (_DealerLogo = /*#__PURE__*/_react["default"].createElement(_dealerLogo["default"], {
        logo: logo,
        name: name
      })))));
    });
  };
  return DealerDetails;
}(_react.Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(DealerDetails);
exports["default"] = _default;